import CacheSlug from './CacheSlug';

export {
  // Disabling this rule till more than one export is needed
  // eslint-disable-next-line import/prefer-default-export
  CacheSlug,
};
